import { createActions, createReducer } from 'reduxsauce';
import { cloneDeep, forEach, set } from 'lodash';

export { default as thunks } from './thunks';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	currentStep  : 0,
	queryString  : '1',
	loading      : false,
	signUpToken  : '',
	liveValidate : {
		personalInfo : false,
		contactInfo  : false,
	},
	userDetails : {
		personalInfo : {
			firstname       : '',
			lastname        : '',
			email           : '',
			phoneno         : '',
			company         : '',
			password        : '',
			confirmPassword : '',
		},
		contactInfo : {
			address : '',
			city    : '',
			state   : null,
			zip     : '',
		},
	},
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	changeSignupValue        : ['property', 'value'],
	userDetailsChanged       : ['property', 'data'],
	liveValidateChanged      : ['property', 'data'],
	billingInfoChanged       : ['formData'],
	changeBillingAddressData : ['propertyObj'],
	updateStoreProperties    : ['collection'],
	resetSignup              : [],
}, { prefix : '@signup/' });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {

	[Types.CHANGE_SIGNUP_VALUE] : (state, { property, value }) => {
		const newState = cloneDeep(state);
		newState[property] = value;
		return newState;
	},

	[Types.USER_DETAILS_CHANGED] : (state, { property, data }) => {
		const newState = cloneDeep(state);
		newState.userDetails[property] = data;
		return newState;
	},

	[Types.LIVE_VALIDATE_CHANGED] : (state, { property, data }) => {
		const newState = cloneDeep(state);
		newState.liveValidate[property] = data;
		return newState;
	},

	[Types.UPDATE_STORE_PROPERTIES] : (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, (value, property) => set(newState, property, value));

		return newState;
	},

	[Types.RESET_SIGNUP] : () => {
		const newState = cloneDeep(INITIAL_STATE);
		return newState;
	},

});

export default Creators;
